import { CHECKOUT_ITEM_TYPE_EXPERIENCE, CHECKOUT_ITEM_TYPE_TRANSFER } from 'constants/checkout'
import uuidV4 from 'lib/string/uuidV4Utils'

interface TicketPrimitive {
  ticket: App.ExperienceItemTicket | App.PackageAddonItem,
  count: number;
}

export interface ExperienceDetails {
  date?: string;
  time?: string;
  language?: string;
  pickupPoint?: string;
  redemptionLocation?: string;
}

export function exceedsTicketAvailability(count: number, availability: number) {
  if (availability === -1) { return false } // -1 means infinite availability
  return count > availability
}

export function generateExperienceCheckoutTicket(item: TicketPrimitive): App.Checkout.ExperienceItemTicket {
  const ticket = item.ticket
  if (ticket?.id) {
    // experience ticket
    const expTicket = ticket as App.ExperienceItemTicket
    return {
      ticketId: ticket.id,
      name: ticket.name,
      count: item.count,
      ...(exceedsTicketAvailability(item.count, expTicket.purchaseLimit.max) && { unavailable: true }),
    }
  } else {
    // package addon item
    // I'm going to assume this works, but let's create better type narrowing in future
    const packageAddon = ticket as App.PackageAddonItem
    return {
      ticketId: packageAddon.idSalesforceExternal,
      name: packageAddon.fareTypeText,
      count: item.count,
    }
  }
}

export function generateExperienceCheckoutItem(
  experience: App.ExperienceOffer,
  details: ExperienceDetails,
  tickets: TicketPrimitive[],
  cartItem?: App.Checkout.ExperienceItem,
  isBuyNowBookLater?: boolean,
  isGift?: boolean,
): App.Checkout.ExperienceItem {
  const transformedTickets = tickets.map(generateExperienceCheckoutTicket)
  const item: App.Checkout.ExperienceItem = {
    itemId: cartItem?.itemId || uuidV4(),
    transactionKey: uuidV4(),
    itemType: CHECKOUT_ITEM_TYPE_EXPERIENCE,
    tickets: transformedTickets,
    experienceId: experience.id,
    leExclusive: experience.leExclusive,
    date: details.date ?? 'any',
    isBuyNowBookLater: isBuyNowBookLater ?? false,
    isGift: !!isGift,
  }

  details.time && (item.time = details.time)
  details.language && (item.languageId = details.language)
  details.pickupPoint && (item.pickupPointId = details.pickupPoint)
  details.redemptionLocation && (item.redemptionLocationId = details.redemptionLocation)

  return item
}

export function generateTransferCheckoutItem(
  experience: App.ExperienceOffer,
  transfer: App.ExperienceTransferView,
  cartItem?: App.Checkout.TransferItem,
): App.Checkout.TransferItem {
  const item: App.Checkout.TransferItem = {
    itemId: cartItem?.itemId || uuidV4(),
    transactionKey: uuidV4(),
    itemType: CHECKOUT_ITEM_TYPE_TRANSFER,
    transfer,
    experienceId: experience.id,
    offerType: experience.productType,
  }

  return item
}
